// extracted by mini-css-extract-plugin
export var backupIcon = "_ou-1";
export var image = "_ou-0";